import React from "react";
import { Avatar, Modal } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { DashboardOutlined, UserAddOutlined, LogoutOutlined } from "@ant-design/icons";
import { logout } from "../store/authSlice";

const navItems = [
  { key: "dashboard",         icon: <DashboardOutlined />, label: "Dashboard" },
  { key: "vendor-onboarding", icon: <UserAddOutlined />,   label: "Onboard Vendor" },
];

export default function Sidebar() {
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate  = useNavigate();
  const location  = useLocation();

  const currentPath = location.pathname.replace("/", "") || "dashboard";

  const handleLogoutClick = () => {
    Modal.confirm({
      title: "Log out?",
      okText: "Log Out",
      okButtonProps: { danger: true },
      onOk: () => {
        dispatch(logout());
        navigate("/login");
      },
    });
  };

  return (
    <div
      style={{
        width: 220,
        background: "linear-gradient(160deg, #123b31 0%, #1a1540 100%)",
        color: "#fff",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* LOGO */}
      <div style={{ padding: 16, display: "flex", alignItems: "center", gap: 10 }}>
        <img src="/icon.png" alt="Kidodom" style={{ width: 36, height: 36, borderRadius: 10, objectFit: "contain" }} />
        <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <span style={{ fontSize: 18, fontWeight: 700, letterSpacing: "-0.3px" }}>Kidodom</span>
          <span style={{ fontSize: 11, color: "rgba(255,255,255,0.5)", letterSpacing: "1.5px", textTransform: "uppercase" }}>
            Sales Portal
          </span>
        </div>
      </div>

      {/* NAV ITEMS */}
      <div className="sidebar-scroll" style={{ flex: 1, overflowY: "auto" }}>
        {navItems.map((n) => {
          const isActive = currentPath === n.key;
          return (
            <div
              key={n.key}
              onClick={() => navigate(`/${n.key}`)}
              style={{
                padding: "12px 16px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: 10,
                background: isActive ? "rgba(255,255,255,0.15)" : "transparent",
                transition: "0.2s",
              }}
            >
              <span>{n.icon}</span>
              <span>{n.label}</span>
            </div>
          );
        })}
      </div>

      {/* PROFILE / LOGOUT */}
      <div
        onClick={handleLogoutClick}
        style={{
          padding: 12,
          borderTop: "1px solid rgba(255,255,255,0.1)",
          display: "flex",
          alignItems: "center",
          gap: 10,
          cursor: "pointer",
          background: "rgba(255,255,255,0.05)",
        }}
      >
        <Avatar style={{ background: "#0f6e56" }}>
          {(user?.name || "S").charAt(0).toUpperCase()}
        </Avatar>
        <div style={{ overflow: "hidden", flex: 1 }}>
          <div style={{ fontSize: 13, fontWeight: 500 }}>{user?.name || "Sales"}</div>
          <div style={{ fontSize: 11, opacity: 0.6 }}>{user?.role?.name || "Sales"}</div>
        </div>
        <LogoutOutlined style={{ opacity: 0.6 }} />
      </div>
    </div>
  );
}
